import { createSlice, PayloadAction } from '@reduxjs/toolkit'

const initialState: any = {
  intercom: {},
}

export const libraraiesDetails = createSlice({
  name: 'librariesData',
  initialState,
  reducers: {
    setIntercomDetails(state, action: PayloadAction<any>) {
      return {
        ...state,
        intercom: {
          ...action.payload,
        },
      }
    },
  },
})

export const { setIntercomDetails } = libraraiesDetails.actions
export default libraraiesDetails.reducer
